import "./HomeIllustration.css";

export const HomeIllustration = () => {
    return (
        <svg className="wai-home-illustation" viewBox="0 -10 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" overflow="visible">
            <g clipPath="url(#clip0_7495_40041)">
                <g className="wai-home-illustation-stars">
                    <path d="M51.9297 84.4512C51.9297 85.0536 51.4413 85.542 50.8389 85.542H2.22441C1.62197 85.542 1.13359 85.0536 1.13359
                84.4512V39.5952C1.13359 38.9928 1.62197 38.5044 2.22441 38.5044H29.445C29.6634 38.5044 29.8769 38.4388 30.0576
                38.3162L34.574 35.2508C35.2983 34.7592 36.2774 35.278 36.2774 36.1534V37.4136C36.2774 38.0161 36.7658 38.5044
                37.3682 38.5044H50.8389C51.4413 38.5044 51.9297 38.9928 51.9297 39.5952V84.4512Z"
                    fill="#4767FE"
                    stroke="#3C3C3C"
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                    />
                    <path d="M5.02344 51.0207C5.02344 44.7836 10.0795 39.7275 16.3166 39.7275H37.3629C43.5999 39.7275 48.656 44.7836 48.656 51.0207V72.067C48.656 78.304 43.5999 83.3601 37.3629 83.3601H16.3166C10.0795 83.3601 5.02344 78.304 5.02344 72.067V51.0207Z" fill="#4767FE" />
                    <g filter="url(#filter0_d_7495_40041)">
                        <path fillRule="evenodd"
                            clipRule="evenodd"
                            d="M21.2426 49.5822C21.1586 49.2403 20.852 49 20.5 49C20.148 49
                    19.8414 49.2403 19.7574 49.5822L19.6197 50.1424C19.0677 52.3889 17.2974 54.1329 15.043 54.6513L14.5933
                    54.7547C14.2461 54.8346 14 55.1437 14 55.5C14 55.8563 14.2461 56.1654 14.5933 56.2453L15.043 56.3487C17.2974
                    56.8671 19.0677 58.6111 19.6197 60.8576L19.7574 61.4178C19.8414 61.7597 20.148 62 20.5 62C20.852 62 21.1586
                    61.7597 21.2426 61.4178L21.3803 60.8576C21.9323 58.6111 23.7026 56.8671 25.957 56.3487L26.4067 56.2453C26.7539
                    56.1654 27 55.8563 27 55.5C27 55.1437 26.7539 54.8346 26.4067 54.7547L25.957 54.6513C23.7026 54.1329 21.9323
                    52.3889 21.3803 50.1424L21.2426 49.5822Z"
                            fill="white"
                        />
                        <path fillRule="evenodd"
                            clipRule="evenodd"
                            d="M30.7968 54.9171C30.7063 54.5841 30.4039 54.3529
                    30.0588 54.3529C29.7137 54.3529 29.4114 54.5841 29.3209 54.9171L28.3058 58.6527C27.7481 60.705 26.166
                     62.3213 24.1261 62.9228L20.6661 63.943C20.3409 64.0389 20.1176 64.3374 20.1176 64.6765C20.1176 65.0155
                      20.3409 65.3141 20.6661 65.41L24.1261 66.4302C26.166 67.0317 27.7481 68.648 28.3058 70.7003L29.3209
                       74.4358C29.4114 74.7689 29.7137 75 30.0588 75C30.4039 75 30.7063 74.7689 30.7968 74.4358L31.8119
                        70.7003C32.3696 68.648 33.9517 67.0317 35.9916 66.4302L39.4516 65.41C39.7768 65.3141 40 65.0155
                         40 64.6765C40 64.3374 39.7768 64.0389 39.4516 63.943L35.9916 62.9228C33.9517 62.3213 32.3696
                         60.705 31.8119 58.6527L30.7968 54.9171Z"
                            fill="white"
                        />
                        <path d="M20.859 49.6765L21.2426 49.5822L20.859 49.6765L20.9967 50.2367C21.5843 52.628 23.4687
                    54.4844 25.8685 55.0363L26.3182 55.1397C26.486 55.1783 26.605 55.3277 26.605 55.5C26.605 55.6723
                    26.486 55.8217 26.3182 55.8603L25.8685 55.9637C23.4687 56.5156 21.5843 58.372 20.9967 60.7633L20.859
                    61.3235L21.2426 61.4178L20.859 61.3235C20.8184 61.4888 20.6702 61.605 20.5 61.605C20.3298 61.605
                    20.1816 61.4888 20.141 61.3235L19.7574 61.4178L20.141 61.3235L20.0033 60.7633C19.4157 58.372
                    17.5313 56.5156 15.1315 55.9637L14.6818 55.8603C14.514 55.8217 14.395 55.6723 14.395
                    55.5C14.395 55.3277 14.514 55.1783 14.6818 55.1397L15.1315 55.0363C17.5313 54.4844
                    19.4157 52.628 20.0033 50.2367L20.141 49.6765L19.7598 49.5828L20.141 49.6765C20.1816
                    49.5112 20.3298 49.395 20.5 49.395C20.6702 49.395 20.8184 49.5112 20.859 49.6765ZM30.0588
                    54.7479C30.2257 54.7479 30.3718 54.8597 30.4156 55.0207L31.4307 58.7563C32.0244 60.9409
                    33.7084 62.6614 35.8799 63.3016L39.3399 64.3219C39.4971 64.3682 39.605 64.5126 39.605
                    64.6765C39.605 64.8404 39.4971 64.9847 39.3399 65.0311L35.8799 66.0513C33.7084 66.6916
                    32.0244 68.4121 31.4307 70.5967L30.4156 74.3322C30.3718 74.4932 30.2257 74.605 30.0588
                    74.605C29.892 74.605 29.7458 74.4932 29.7021 74.3322L28.6869 70.5967C28.0933 68.4121
                    26.4092 66.6916 24.2378 66.0513L20.7778 65.0311C20.6206 64.9847 20.5126 64.8404 20.5126
                    64.6765C20.5126 64.5126 20.6206 64.3682 20.7778 64.3219L20.6661 63.943L20.7778
                    64.3219L24.2378 63.3016C26.4092 62.6614 28.0933 60.9409 28.6869 58.7563L29.7021
                    55.0207C29.7458 54.8597 29.892 54.7479 30.0588 54.7479Z"
                        stroke="#102FC3"
                        strokeWidth="0.79"
                        />
                    </g>
                </g>
                <g className="wai-home-illustation-face">
                    <path d="M43.2031 1.54882C43.2031 0.946378 43.6915 0.458008 44.2939 0.458008H92.9084C93.5108 0.458008
                93.9992 0.946382 93.9992 1.54882V46.4048C93.9992 47.0072 93.5108 47.4956 92.9084 47.4956H65.6878C65.4694
                47.4956 65.256 47.5611 65.0752 47.6838L60.5588 50.7492C59.8345 51.2408 58.8554 50.722 58.8554
                49.8466V48.5864C58.8554 47.9839 58.367 47.4956 57.7646 47.4956H44.2939C43.6915 47.4956 43.2031
                47.0072 43.2031 46.4048V1.54882Z"
                    fill="white"
                    stroke="#3C3C3C"
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                    />
                    <path d="M84.5057 23.5148C84.5057 28.3058 82.5911 32.1188 79.2464 35.2021C76.1631 38.5468 71.7657
                41.0457 66.9747 41.0457C58.5836 41.0457 51.7812 34.2434 51.7812 25.8522C51.7812 21.0612 53.5343 18.2555
                56.4562 14.7493C59.9052 10.6104 64.5212 8.32129 69.3122 8.32129C77.7033 8.32129 84.5057 15.1236 84.5057
                23.5148Z"
                    fill="#3C3C3C"
                    />
                    <path fillRule="evenodd"
                        clipRule="evenodd"
                        d="M69.2382 36.6825C76.4675 36.6825 82.328 30.822 82.328
                23.5927C82.328 16.3634 76.4675 10.5029 69.2382 10.5029C62.0089 10.5029 56.1484 16.3634 56.1484 23.5927C56.1484
                30.822 62.0089 36.6825 69.2382 36.6825ZM63.668 22.4786C64.5909 22.4786 65.3391 21.7305 65.3391 20.8076C65.3391
                19.8847 64.5909 19.1365 63.668 19.1365C62.7451 19.1365 61.997 19.8847 61.997 20.8076C61.997 21.7305 62.7451
                 22.4786 63.668 22.4786ZM76.4793 20.8076C76.4793 21.7305 75.7311 22.4786 74.8082 22.4786C73.8854 22.4786
                 73.1372 21.7305 73.1372 20.8076C73.1372 19.8847 73.8854 19.1365 74.8082 19.1365C75.7311 19.1365 76.4793
                 19.8847 76.4793 20.8076ZM62.824 26.4992C62.5835 26.1992 62.1453 26.1509 61.8452 26.3914C61.5452 26.6319
                 61.4969 27.0701 61.7375 27.3702C63.4972 29.5654 66.2036 30.973 69.2382 30.973C72.2728 30.973 74.9792
                 29.5654 76.7389 27.3702C76.9795 27.0701 76.9312 26.6319 76.6312 26.3914C76.3311 26.1509 75.8929 26.1992
                 75.6524 26.4992C74.1456 28.3789 71.8325 29.5805 69.2382 29.5805C66.6439 29.5805 64.3308 28.3789 62.824 26.4992Z"
                        fill="white"
                    />
                </g>
            </g>
            <defs>
                <filter id="filter0_d_7495_40041" x="13" y="49" width="27" height="28" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="-1" dy="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.184314 0 0 0 0 0.764706 0 0 0 1 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7495_40041" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_7495_40041" result="shape" />
                </filter>
                <clipPath id="clip0_7495_40041">
                    <rect width="96" height="86" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
